document.addEventListener('DOMContentLoaded', () => {
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' Kč';
  }

  function updateProductCardsUI(cart) {
    document.querySelectorAll('.product-card[data-variant-id]').forEach(card => {
      var vid = card.dataset.variantId;
      var item = cart.items.find(i => String(i.variant_id) === vid);
      var qty = item ? item.quantity : 0;

      var atcWrapper = card.querySelector('.product-card__actions--initial');
      var qtyWrapper = card.querySelector('.product-card__actions--qty');
      var qtyValue = card.querySelector('.product-card__qty-value');

      if (atcWrapper && qtyWrapper && qtyValue) {
        if (qty > 0) {
          atcWrapper.style.display = 'none';
          qtyWrapper.style.display = 'flex';
          qtyValue.textContent = qty;
        } else {
          atcWrapper.style.display = '';
          qtyWrapper.style.display = 'none';
        }
      }
    });
  }

  function updateHeaderCart(cart) {
    document.querySelectorAll('.header__cart-count').forEach(el => {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) {
        el.classList.remove('hidden');
        el.classList.add('bump');
        setTimeout(() => el.classList.remove('bump'), 200);
      } else {
        el.classList.add('hidden');
      }
    });
  }

  function updateCartPageUI(cart) {
    document.querySelectorAll('.cart-footer__subtotal-price').forEach(el => {
      el.textContent = formatMoney(cart.total_price);
    });

    document.querySelectorAll('.cart-hero__count').forEach(el => {
      var c = cart.item_count;
      var word = c === 1 ? 'produkt' : (c >= 2 && c <= 4 ? 'produkty' : 'produktů');
      el.textContent = c + ' ' + word;
    });

    cart.items.forEach((item, idx) => {
      var row = document.querySelector('.cart-item[data-line="' + (idx + 1) + '"]');
      if (!row) return;

      var totalEl = row.querySelector('.cart-item__total');
      if (totalEl) totalEl.textContent = formatMoney(item.line_price);

      var qtyInput = row.querySelector('[data-cart-qty]');
      if (qtyInput) qtyInput.value = item.quantity;

      var minusBtn = row.querySelector('[data-cart-minus]');
      if (minusBtn) minusBtn.disabled = false;

      var plusBtn = row.querySelector('[data-cart-plus]');
      var maxQty = parseInt(row.dataset.maxQty) || 9999;
      if (plusBtn) plusBtn.disabled = item.quantity >= maxQty;
    });
  }

  function updateCartPopover(cart) {
    var countEl = document.querySelector('[data-cart-popover-count]');
    if (countEl) countEl.textContent = cart.item_count;

    var totalEl = document.querySelector('[data-cart-popover-total]');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    var itemsEl = document.querySelector('[data-cart-popover-items]');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="cart-popover__empty">' + (document.querySelector('.cart-popover__empty') ? document.querySelector('.cart-popover__empty').textContent : 'Váš košík je prázdný') + '</p>';
      var footer = document.querySelector('.cart-popover__footer');
      if (footer) footer.style.display = 'none';
      return;
    }

    var html = '';
    cart.items.forEach(function(item) {
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="' + item.product_title.replace(/"/g, '&quot;') + '" width="80" height="80" loading="lazy">'
        : '';
      html += '<div class="cart-popover__item">'
        + '<div class="cart-popover__item-image">' + imgHtml + '</div>'
        + '<div class="cart-popover__item-info">'
        + '<a href="' + item.url + '" class="cart-popover__item-title">' + item.product_title + '</a>'
        + '<span class="cart-popover__item-meta">' + item.quantity + ' &times; ' + formatMoney(item.price) + '</span>'
        + '</div></div>';
    });
    itemsEl.innerHTML = html;

    var footer = document.querySelector('.cart-popover__footer');
    if (footer) footer.style.display = '';
  }

  function updateAllUI(cart) {
    updateProductCardsUI(cart);
    updateHeaderCart(cart);
    updateCartPageUI(cart);
    updateCartPopover(cart);
  }

  async function cartAdd(variantId, quantity) {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] })
    });
    if (!res.ok) {
      var errData = await res.json().catch(() => ({}));
      throw new Error(errData.description || errData.message || 'Chyba');
    }
    return res.json();
  }

  async function cartChange(line, quantity) {
    var res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    });
    if (!res.ok) {
      var errData = await res.json().catch(() => ({}));
      throw new Error(errData.description || errData.message || 'Chyba');
    }
    return res.json();
  }

  async function getCart() {
    var res = await fetch('/cart.js');
    return res.json();
  }

  // ─── Cart popover: refresh on hover ───
  (function() {
    var wrap = document.querySelector('[data-cart-popover-wrap]');
    if (!wrap) return;
    var fetching = false;
    wrap.addEventListener('mouseenter', async function() {
      if (fetching) return;
      fetching = true;
      try {
        var cart = await getCart();
        updateCartPopover(cart);
        updateHeaderCart(cart);
      } catch (e) {}
      fetching = false;
    });
  })();

  // ─── Cart confirmation dialog ───
  function showCartDialog(title, price, imageUrl) {
    var dialog = document.getElementById('cart-confirmation-dialog');
    if (!dialog) return;

    var titleEl = document.getElementById('cart-dialog-product-title');
    var priceEl = document.getElementById('cart-dialog-product-price');
    var imageEl = document.getElementById('cart-dialog-image');

    if (titleEl) titleEl.textContent = title || '';
    if (priceEl) priceEl.textContent = price || '';
    if (imageEl) {
      imageEl.innerHTML = imageUrl
        ? '<img src="' + imageUrl + '" alt="' + (title || '').replace(/"/g, '&quot;') + '" width="72" height="72">'
        : '';
    }

    dialog.showModal();
  }

  (function initCartDialogClose() {
    var dialog = document.getElementById('cart-confirmation-dialog');
    if (!dialog) return;

    dialog.querySelectorAll('[data-cart-dialog-close]').forEach(function(btn) {
      btn.addEventListener('click', function() { dialog.close(); });
    });

    dialog.addEventListener('click', function(e) {
      if (e.target === dialog) dialog.close();
    });
  })();

  // ─── Product card quick add / quantity change ───
  document.addEventListener('click', async (e) => {
    var btn = e.target.closest('.js-cart-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    if (btn.classList.contains('loading')) return;

    var card = btn.closest('.product-card');
    if (!card) return;

    var variantId = card.dataset.variantId;
    if (!variantId) return;

    var action = btn.dataset.action;
    btn.classList.add('loading');

    try {
      if (action === 'add') {
        await cartAdd(variantId, 1);
        var cart = await getCart();
        updateAllUI(cart);
        showCartDialog(
          card.dataset.productTitle,
          card.dataset.productPrice,
          card.dataset.productImage
        );
      } else {
        var qtyEl = card.querySelector('.product-card__qty-value');
        var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0;
        var newQty = action === 'plus' ? currentQty + 1 : Math.max(0, currentQty - 1);

        var updates = {};
        updates[String(variantId)] = newQty;
        var res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
        if (!res.ok) throw new Error('Update failed');
        var cart = await getCart();
        updateAllUI(cart);
      }
    } catch (err) {
      console.error('Cart error:', err);
    } finally {
      btn.classList.remove('loading');
    }
  });

  // ─── PDP: cart quantity indicator ───
  function updatePdpCartQty(cart) {
    var wrap = document.querySelector('[data-pdp-cart-qty]');
    if (!wrap) return;

    var vid = wrap.dataset.variantId;
    var item = cart.items.find(i => String(i.variant_id) === vid);
    var qty = item ? item.quantity : 0;
    var valueEl = wrap.querySelector('[data-pdp-cart-value]');

    if (qty > 0) {
      wrap.style.display = '';
      if (valueEl) valueEl.textContent = qty;
    } else {
      wrap.style.display = 'none';
    }
  }

  // ─── Product detail page: add to cart button ───
  var pdpAtcBtn = document.querySelector('[data-atc-btn]');
  if (pdpAtcBtn) {
    pdpAtcBtn.addEventListener('click', async function() {
      if (pdpAtcBtn.disabled) return;

      var variantSelect = document.getElementById('variant-select');
      var qtyInput = document.querySelector('.pdp__qty-input');
      var variantId = variantSelect ? variantSelect.value : pdpAtcBtn.dataset.variantId;
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      var originalHTML = pdpAtcBtn.innerHTML;
      pdpAtcBtn.disabled = true;
      pdpAtcBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" class="spin-icon"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2" stroke-dasharray="31" stroke-dashoffset="10" stroke-linecap="round"/></svg>';

      try {
        await cartAdd(variantId, quantity);
        var cart = await getCart();
        updateAllUI(cart);
        updatePdpCartQty(cart);

        var pdp = document.querySelector('.pdp');
        var title = pdp ? (pdp.querySelector('.pdp__title') || {}).textContent : '';
        var price = pdp ? (pdp.querySelector('.pdp__price') || {}).textContent : '';
        var imgEl = pdp ? pdp.querySelector('.pdp__img') : null;
        var imageUrl = imgEl ? imgEl.src : '';

        showCartDialog(title, price, imageUrl);
      } catch (err) {
        console.error('Add to cart error:', err);
      } finally {
        pdpAtcBtn.disabled = false;
        pdpAtcBtn.innerHTML = originalHTML;
      }
    });
  }

  // ─── PDP: cart quantity +/- ───
  document.addEventListener('click', async (e) => {
    var minusBtn = e.target.closest('[data-pdp-cart-minus]');
    var plusBtn = e.target.closest('[data-pdp-cart-plus]');
    if (!minusBtn && !plusBtn) return;

    var btn = minusBtn || plusBtn;
    var wrap = btn.closest('[data-pdp-cart-qty]');
    if (!wrap) return;

    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('loading')) return;

    var vid = wrap.dataset.variantId;
    var valueEl = wrap.querySelector('[data-pdp-cart-value]');
    var currentQty = valueEl ? parseInt(valueEl.textContent, 10) || 0 : 0;
    var newQty = minusBtn ? Math.max(0, currentQty - 1) : currentQty + 1;

    if (valueEl) valueEl.textContent = newQty;
    btn.classList.add('loading');

    try {
      var updates = {};
      updates[String(vid)] = newQty;
      var res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
      if (!res.ok) throw new Error('Update failed');

      var cart = await getCart();
      updateAllUI(cart);
      updatePdpCartQty(cart);
    } catch (err) {
      console.error('PDP cart qty error:', err);
      if (valueEl) valueEl.textContent = currentQty;
    } finally {
      btn.classList.remove('loading');
    }
  });

  // ─── Cart page: quantity +/- and remove ───
  var cartDebounce = null;

  document.addEventListener('click', async (e) => {
    var minusBtn = e.target.closest('[data-cart-minus]');
    var plusBtn = e.target.closest('[data-cart-plus]');
    var removeBtn = e.target.closest('[data-cart-remove]');

    if (!minusBtn && !plusBtn && !removeBtn) return;
    e.preventDefault();
    e.stopPropagation();

    var row = (minusBtn || plusBtn || removeBtn).closest('.cart-item');
    if (!row) return;

    var line = parseInt(row.dataset.line);
    var maxQty = parseInt(row.dataset.maxQty) || 9999;
    var input = row.querySelector('[data-cart-qty]');
    var errorEl = row.querySelector('.cart-item__error');

    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    var currentQty = input ? parseInt(input.value) || 0 : 0;
    var newQty;

    if (removeBtn) {
      newQty = 0;
    } else if (minusBtn) {
      newQty = Math.max(0, currentQty - 1);
    } else {
      if (currentQty >= maxQty) {
        if (errorEl) {
          errorEl.textContent = 'Maximální dostupné množství: ' + maxQty;
          errorEl.hidden = false;
        }
        return;
      }
      newQty = currentQty + 1;
    }

    if (input) input.value = newQty;

    var unitPrice = parseInt(row.dataset.unitPrice) || 0;
    var totalEl = row.querySelector('.cart-item__total');
    if (totalEl && newQty > 0) {
      totalEl.textContent = formatMoney(unitPrice * newQty);
    }

    row.classList.add('cart-item--updating');

    clearTimeout(cartDebounce);
    cartDebounce = setTimeout(async () => {
      try {
        var cart = await cartChange(line, newQty);
        updateHeaderCart(cart);

        document.querySelectorAll('.cart-footer__subtotal-price').forEach(el => {
          el.textContent = formatMoney(cart.total_price);
        });

        document.querySelectorAll('.cart-hero__count').forEach(el => {
          var c = cart.item_count;
          var word = c === 1 ? 'produkt' : (c >= 2 && c <= 4 ? 'produkty' : 'produktů');
          el.textContent = c + ' ' + word;
        });

        if (newQty === 0) {
          row.style.transition = 'opacity 0.3s ease, max-height 0.4s ease';
          row.style.opacity = '0';
          row.style.maxHeight = row.offsetHeight + 'px';
          requestAnimationFrame(() => {
            row.style.maxHeight = '0';
            row.style.overflow = 'hidden';
            row.style.padding = '0';
          });
          setTimeout(() => {
            row.remove();
            if (cart.item_count === 0) {
              location.reload();
            } else {
              reindexCartRows();
            }
          }, 400);
        } else {
          var matchedItem = cart.items.find(i => String(i.variant_id) === row.dataset.variantId);
          if (matchedItem) {
            if (totalEl) totalEl.textContent = formatMoney(matchedItem.line_price);
            if (input) input.value = matchedItem.quantity;

            if (matchedItem.quantity < newQty && errorEl) {
              errorEl.textContent = 'Maximální dostupné množství: ' + matchedItem.quantity;
              errorEl.hidden = false;
            }
          }
          row.classList.remove('cart-item--updating');
        }

        updateProductCardsUI(cart);

      } catch (err) {
        console.error('Cart update error:', err);
        if (errorEl) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        }
        row.classList.remove('cart-item--updating');
      }
    }, 300);
  });

  function reindexCartRows() {
    document.querySelectorAll('.cart-item').forEach((row, idx) => {
      row.dataset.line = idx + 1;
    });
  }

  // ─── Cart page: manual input change ───
  document.addEventListener('change', async (e) => {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;

    var row = input.closest('.cart-item');
    if (!row) return;

    var line = parseInt(row.dataset.line);
    var maxQty = parseInt(row.dataset.maxQty) || 9999;
    var newQty = parseInt(input.value) || 0;
    var errorEl = row.querySelector('.cart-item__error');

    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    if (newQty > maxQty) {
      newQty = maxQty;
      input.value = newQty;
      if (errorEl) {
        errorEl.textContent = 'Maximální dostupné množství: ' + maxQty;
        errorEl.hidden = false;
      }
    }

    if (newQty < 0) newQty = 0;

    var unitPrice = parseInt(row.dataset.unitPrice) || 0;
    var totalEl = row.querySelector('.cart-item__total');
    if (totalEl && newQty > 0) {
      totalEl.textContent = formatMoney(unitPrice * newQty);
    }

    row.classList.add('cart-item--updating');

    try {
      var cart = await cartChange(line, newQty);
      updateHeaderCart(cart);

      document.querySelectorAll('.cart-footer__subtotal-price').forEach(el => {
        el.textContent = formatMoney(cart.total_price);
      });

      document.querySelectorAll('.cart-hero__count').forEach(el => {
        var c = cart.item_count;
        var word = c === 1 ? 'produkt' : (c >= 2 && c <= 4 ? 'produkty' : 'produktů');
        el.textContent = c + ' ' + word;
      });

      if (newQty === 0) {
        row.style.transition = 'opacity 0.3s ease, max-height 0.4s ease';
        row.style.opacity = '0';
        setTimeout(() => {
          row.remove();
          if (cart.item_count === 0) location.reload();
          else reindexCartRows();
        }, 350);
      } else {
        var matchedItem = cart.items.find(i => String(i.variant_id) === row.dataset.variantId);
        if (matchedItem) {
          if (totalEl) totalEl.textContent = formatMoney(matchedItem.line_price);
          if (input) input.value = matchedItem.quantity;

          if (matchedItem.quantity < newQty && errorEl) {
            errorEl.textContent = 'Maximální dostupné množství: ' + matchedItem.quantity;
            errorEl.hidden = false;
          }
        }
        row.classList.remove('cart-item--updating');
      }

      updateProductCardsUI(cart);

    } catch (err) {
      console.error('Cart input error:', err);
      if (errorEl) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      }
      row.classList.remove('cart-item--updating');
    }
  });
});
